import React from "react";
import { Outlet, Navigate } from "react-router-dom";
const PrivateRoute = () => {
  const token = localStorage.getItem("tokenn");
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;